import React from "react";

const NotFoundPage: React.FC = () => {
  return <div>404 not found.</div>;
};

export default NotFoundPage;
